var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-snippet"},[_c('span',[_vm._v(_vm._s(_vm.initials))]),_c('span',{attrs:{"title":_vm.name}},[_vm._v(_vm._s(_vm.name))]),_c('span',[_vm._v(_vm._s(_vm.formattedDate))])])}
var staticRenderFns = []

export { render, staticRenderFns }